import { Events } from '@vimeo/bigpicture-client';
import { getPageNameFromPath } from '@vimeo/ui/core/F2PJoinLogin/utils';
import getDeviceType from '@vimeo/ui/core/utils/getDeviceType';
import {
  ActionBpContext,
  buildActionBpContext,
  buildProductAnalyticsBpContext,
  buildWebBpContext,
  ProductAnalyticsBpContext,
  sendBpEventWithContexts,
  WebBpContext,
} from '@vimeo/use-tracking';
import { useViewer, Viewer } from '@vimeo/viewer';

export interface HelpPanelEvent {
  actionType?: ActionBpContext['action_type'];
  additionalFields?: Record<string, unknown>;
  copy?: string | null;
  element?: ProductAnalyticsBpContext['element'];
  eventName?: Events;
  feature?: ProductAnalyticsBpContext['feature'];
  flow?: ProductAnalyticsBpContext['flow'];
  product?: ProductAnalyticsBpContext['product'];
  target?: WebBpContext['target'];
  targetPath?: WebBpContext['target_path'];
}

export interface HelpPanelEventWithViewer extends HelpPanelEvent {
  viewer: Viewer;
}

/** combine viewer context and event tracking helper */
export const useTrackHelpPanelEvent = () => {
  const viewer = useViewer();

  return (args: HelpPanelEvent) => trackHelpPanelEvent({ ...args, viewer });
};

const trackHelpPanelEvent = ({
  actionType = 'click',
  copy = null,
  element,
  eventName = 'vimeo.in_app_support_panel_launch_button',
  feature = 'support',
  flow = null,
  product = 'in_app_support',
  target = null,
  targetPath = null,
  viewer,
}: HelpPanelEventWithViewer) => {
  const user = viewer?.user;
  const teamUser = viewer?.teamUser;
  const pageName: WebBpContext['page_name'] = getPageNameFromPath(window.location.pathname, user);
  const referrerPageName: WebBpContext['referrer_page_name'] = document.referrer
    ? getPageNameFromPath(`/${document.referrer}`, user)
    : null;

  const contexts = {
    ...buildActionBpContext({
      action_type: actionType,
      feature: null,
    }),
    ...buildWebBpContext({
      page_name: pageName,
      referrer_page_name: referrerPageName,
      referrer: document.referrer,
      path: window.location.pathname,
      target: window.location.pathname,
      target_path: targetPath,
      copy,
    }),
    ...buildProductAnalyticsBpContext({
      product,
      feature,
      location: 'panel',
      flow,
      element,
      device_type: getDeviceType(),
      is_user_facing_data: null,
    }),
  };

  sendBpEventWithContexts(eventName, contexts);
};
